import { render, staticRenderFns } from "./RegisterWrapper.vue?vue&type=template&id=56467b3b&"
import script from "./RegisterWrapper.vue?vue&type=script&lang=js&"
export * from "./RegisterWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports